/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteExcel } from '../fn/import/delete-excel';
import { DeleteExcel$Params } from '../fn/import/delete-excel';
import { deleteImage } from '../fn/import/delete-image';
import { DeleteImage$Params } from '../fn/import/delete-image';
import { getExcel } from '../fn/import/get-excel';
import { GetExcel$Params } from '../fn/import/get-excel';
import { getImage } from '../fn/import/get-image';
import { GetImage$Params } from '../fn/import/get-image';
import { importExcel } from '../fn/import/import-excel';
import { ImportExcel$Params } from '../fn/import/import-excel';
import { listExcels } from '../fn/import/list-excels';
import { ListExcels$Params } from '../fn/import/list-excels';
import { listImageReferences } from '../fn/import/list-image-references';
import { ListImageReferences$Params } from '../fn/import/list-image-references';
import { PageResource } from '../models/page-resource';
import { ProductImportViolation } from '../models/product-import-violation';
import { Resource } from '../models/resource';
import { uploadExcel } from '../fn/import/upload-excel';
import { UploadExcel$Params } from '../fn/import/upload-excel';
import { uploadExcels } from '../fn/import/upload-excels';
import { UploadExcels$Params } from '../fn/import/upload-excels';
import { uploadImage } from '../fn/import/upload-image';
import { UploadImage$Params } from '../fn/import/upload-image';
import { uploadImages } from '../fn/import/upload-images';
import { UploadImages$Params } from '../fn/import/upload-images';
import { validateExcel } from '../fn/import/validate-excel';
import { ValidateExcel$Params } from '../fn/import/validate-excel';


/**
 * Excel and image import endpoints for product data. Most operations require PRODUCT_ADMIN. Validate and apply (import) operations also accept EASYLOT_ADMIN with an explicit merchantId query parameter.
 */
@Injectable({ providedIn: 'root' })
export class ImportService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getImage()` */
  static readonly GetImagePath = '/import/images/{key}';

  /**
   * Get image.
   *
   * Returns the specified image reference.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getImage()` instead.
   *
   * This method doesn't expect any request body.
   */
  getImage$Response(params: GetImage$Params, context?: HttpContext): Observable<StrictHttpResponse<Resource>> {
    const obs = getImage(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get image.
   *
   * Returns the specified image reference.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getImage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getImage(params: GetImage$Params, context?: HttpContext): Observable<Resource> {
    const resp = this.getImage$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Resource>): Resource => r.body)
    );
  }

  /** Path part for operation `uploadImage()` */
  static readonly UploadImagePath = '/import/images/{key}';

  /**
   * Upload image.
   *
   * Uploads a new content for the given id or if there isn't any images for the given ID then a new one is imported.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadImage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  uploadImage$Response(params: UploadImage$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = uploadImage(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Upload image.
   *
   * Uploads a new content for the given id or if there isn't any images for the given ID then a new one is imported.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadImage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  uploadImage(params: UploadImage$Params, context?: HttpContext): Observable<void> {
    const resp = this.uploadImage$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteImage()` */
  static readonly DeleteImagePath = '/import/images/{key}';

  /**
   * Delete image.
   *
   * Deletes the images for the given ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteImage()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteImage$Response(params: DeleteImage$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteImage(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete image.
   *
   * Deletes the images for the given ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteImage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteImage(params: DeleteImage$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteImage$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getExcel()` */
  static readonly GetExcelPath = '/import/excels/{key}';

  /**
   * Get excel file.
   *
   * Returns the specified excel file reference.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getExcel()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExcel$Response(params: GetExcel$Params, context?: HttpContext): Observable<StrictHttpResponse<Resource>> {
    const obs = getExcel(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get excel file.
   *
   * Returns the specified excel file reference.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getExcel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExcel(params: GetExcel$Params, context?: HttpContext): Observable<Resource> {
    const resp = this.getExcel$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Resource>): Resource => r.body)
    );
  }

  /** Path part for operation `uploadExcel()` */
  static readonly UploadExcelPath = '/import/excels/{key}';

  /**
   * Upload excel file.
   *
   * Uploads a new content for the given id or if there isn't any excel files for the given ID then a new one is imported.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadExcel()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  uploadExcel$Response(params: UploadExcel$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = uploadExcel(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Upload excel file.
   *
   * Uploads a new content for the given id or if there isn't any excel files for the given ID then a new one is imported.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadExcel$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  uploadExcel(params: UploadExcel$Params, context?: HttpContext): Observable<void> {
    const resp = this.uploadExcel$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteExcel()` */
  static readonly DeleteExcelPath = '/import/excels/{key}';

  /**
   * Delete excel file.
   *
   * Deletes the excel file for the given ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteExcel()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteExcel$Response(params: DeleteExcel$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteExcel(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete excel file.
   *
   * Deletes the excel file for the given ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteExcel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteExcel(params: DeleteExcel$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteExcel$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listImageReferences()` */
  static readonly ListImageReferencesPath = '/import/images';

  /**
   * List imported images.
   *
   * Gets the list of imported image names of merchant.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listImageReferences()` instead.
   *
   * This method doesn't expect any request body.
   */
  listImageReferences$Response(params?: ListImageReferences$Params, context?: HttpContext): Observable<StrictHttpResponse<PageResource>> {
    const obs = listImageReferences(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List imported images.
   *
   * Gets the list of imported image names of merchant.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listImageReferences$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listImageReferences(params?: ListImageReferences$Params, context?: HttpContext): Observable<PageResource> {
    const resp = this.listImageReferences$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PageResource>): PageResource => r.body)
    );
  }

  /** Path part for operation `uploadImages()` */
  static readonly UploadImagesPath = '/import/images';

  /**
   * Upload images.
   *
   * Uploads multiple images if any images already exist with an identifier, then those ones will be overwritten.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadImages()` instead.
   *
   * This method doesn't expect any request body.
   */
  uploadImages$Response(params: UploadImages$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = uploadImages(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Upload images.
   *
   * Uploads multiple images if any images already exist with an identifier, then those ones will be overwritten.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadImages$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  uploadImages(params: UploadImages$Params, context?: HttpContext): Observable<void> {
    const resp = this.uploadImages$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listExcels()` */
  static readonly ListExcelsPath = '/import/excels';

  /**
   * List imported excel files.
   *
   * Gets the list of imported excel file names of merchant.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listExcels()` instead.
   *
   * This method doesn't expect any request body.
   */
  listExcels$Response(params?: ListExcels$Params, context?: HttpContext): Observable<StrictHttpResponse<PageResource>> {
    const obs = listExcels(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List imported excel files.
   *
   * Gets the list of imported excel file names of merchant.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listExcels$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listExcels(params?: ListExcels$Params, context?: HttpContext): Observable<PageResource> {
    const resp = this.listExcels$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PageResource>): PageResource => r.body)
    );
  }

  /** Path part for operation `uploadExcels()` */
  static readonly UploadExcelsPath = '/import/excels';

  /**
   * Upload excel files.
   *
   * Uploads multiple images if any excel files already exist with an identifier, then those ones will be overwritten.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadExcels()` instead.
   *
   * This method doesn't expect any request body.
   */
  uploadExcels$Response(params: UploadExcels$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = uploadExcels(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Upload excel files.
   *
   * Uploads multiple images if any excel files already exist with an identifier, then those ones will be overwritten.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadExcels$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  uploadExcels(params: UploadExcels$Params, context?: HttpContext): Observable<void> {
    const resp = this.uploadExcels$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `validateExcel()` */
  static readonly ValidateExcelPath = '/import/excels/{key}/validate';

  /**
   * Validate excel file.
   *
   * Validates the specified excel file and returns a JSON array with import violations.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `validateExcel()` instead.
   *
   * This method doesn't expect any request body.
   */
  validateExcel$Response(params: ValidateExcel$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProductImportViolation>>> {
    const obs = validateExcel(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Validate excel file.
   *
   * Validates the specified excel file and returns a JSON array with import violations.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `validateExcel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  validateExcel(params: ValidateExcel$Params, context?: HttpContext): Observable<Array<ProductImportViolation>> {
    const resp = this.validateExcel$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ProductImportViolation>>): Array<ProductImportViolation> => r.body)
    );
  }

  /** Path part for operation `importExcel()` */
  static readonly ImportExcelPath = '/import/excels/{key}/import';

  /**
   * Apply import product on excel file.
   *
   * Returns the specified image reference.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importExcel()` instead.
   *
   * This method doesn't expect any request body.
   */
  importExcel$Response(params: ImportExcel$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProductImportViolation>>> {
    const obs = importExcel(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Apply import product on excel file.
   *
   * Returns the specified image reference.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importExcel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  importExcel(params: ImportExcel$Params, context?: HttpContext): Observable<Array<ProductImportViolation>> {
    const resp = this.importExcel$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ProductImportViolation>>): Array<ProductImportViolation> => r.body)
    );
  }

}
